import { useI18n } from '../../../i18n'
import { getStandardDisplayName } from '../../../utils/complianceStandard'
import type { UnifiedBlastHit } from '../../../types/unifiedExecutiveContext'
import styles from '../../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  hits: UnifiedBlastHit[]
  mode?: 'compact' | 'expanded'
}

export default function OperationalBlastRadiusPanel({ hits, mode = 'compact' }: Props) {
  const { t } = useI18n()

  if (!hits.length) {
    return (
      <p className={styles.emptyState}>
        {t('enterpriseOperationalUx.context.noBlastPropagation', 'No blast radius propagation')}
      </p>
    )
  }

  return (
    <div>
      <p className={styles.postureMetricLabel}>
        {t('enterpriseOperationalUx.context.blastRadiusPropagation', 'Blast radius propagation')}
      </p>
      {hits.map((hit) => (
        <div key={hit.controlCode} className={mode === 'expanded' ? styles.blastItemExpanded : styles.blastItem}>
          <strong>{hit.controlCode}</strong>
          <span> — {hit.storytelling || hit.summary}</span>
          {hit.impactedStandards?.length ? (
            <span className={styles.scopeLine}>
              {t('enterpriseOperationalUx.affectsStandards', 'Affects')}:{' '}
              {hit.impactedStandards.map((s) => getStandardDisplayName(t, s)).join(', ')}
            </span>
          ) : null}
          {mode === 'expanded' && (hit.systemCount > 0 || hit.standardCount > 0) ? (
            <span className={styles.scopeLine}>
              {hit.systemCount} {t('enterpriseOperationalUx.systemsImpacted', 'systems')} · {hit.standardCount}{' '}
              {t('enterpriseOperationalUx.standardsImpacted', 'standards')}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  )
}
